import { assert } from '@fe/core';
import { ColorSpecification, DataDrivenPropertyValueSpecification, ExpressionSpecification } from 'maplibre-gl';
import { GDFPalletCode } from '../../../gdf/type';
import { getPalette } from '../../../palettes/palettes';
import { BarbColorType, BarbSize, WeatherSettings } from '../../../settings/settings';

export function getBarbsExpression(
    compareExpression: ExpressionSpecification,
    variableExpression?: ExpressionSpecification
): DataDrivenPropertyValueSpecification<string> {
    // prettier-ignore
    const result = ['image', [
        'case',
        ["==", compareExpression, 0], 'fe-weather:wind-0',
        ["<=", compareExpression, 7], 'fe-weather:wind-7',
        ["<=", compareExpression, 12], 'fe-weather:wind-12',
        ["<=", compareExpression, 17], 'fe-weather:wind-17',
        ["<=", compareExpression, 22], 'fe-weather:wind-22',
        ["<=", compareExpression, 27], 'fe-weather:wind-27',
        ["<=", compareExpression, 32], 'fe-weather:wind-32',
        ["<=", compareExpression, 37], 'fe-weather:wind-37',
        ["<=", compareExpression, 42], 'fe-weather:wind-42',
        ["<=", compareExpression, 47], 'fe-weather:wind-47',
        ["<=", compareExpression, 52], 'fe-weather:wind-52',
        ["<=", compareExpression, 57], 'fe-weather:wind-57',
        ["<=", compareExpression, 62], 'fe-weather:wind-62',
        ["<=", compareExpression, 67], 'fe-weather:wind-67',
        ["<=", compareExpression, 72], 'fe-weather:wind-72',
        ["<=", compareExpression, 77], 'fe-weather:wind-77',
        ["<=", compareExpression, 82], 'fe-weather:wind-82',
        ["<=", compareExpression, 87], 'fe-weather:wind-87',
        ["<=", compareExpression, 92], 'fe-weather:wind-92',
        ["<=", compareExpression, 97], 'fe-weather:wind-97',
        ["<=", compareExpression, 102], 'fe-weather:wind-102',
        ["<=", compareExpression, 107], 'fe-weather:wind-107',
        ["<=", compareExpression, 112], 'fe-weather:wind-112',
        ["<=", compareExpression, 117], 'fe-weather:wind-117',
        ["<=", compareExpression, 122], 'fe-weather:wind-122',
        ["<=", compareExpression, 127], 'fe-weather:wind-127',
        ["<=", compareExpression, 132], 'fe-weather:wind-132',
        ["<=", compareExpression, 137], 'fe-weather:wind-137',
        ["<=", compareExpression, 142], 'fe-weather:wind-142',
        ["<=", compareExpression, 147], 'fe-weather:wind-147',
        ["<=", compareExpression, 152], 'fe-weather:wind-152',
        ["<=", compareExpression, 202], 'fe-weather:wind-202',
        'fe-weather:wind-0']
    ];
    if (variableExpression) {
        (result[1] as any[]).splice(1, 0, ['==', variableExpression, 0xfffe], 'fe-weather:wind-variable');
    }

    return result as DataDrivenPropertyValueSpecification<string>;
}

export function getBarbColorExpression(
    settings: WeatherSettings,
    compareExpression: ExpressionSpecification
): DataDrivenPropertyValueSpecification<ColorSpecification> {
    return settings.winds.barbColorType === BarbColorType.auto
        ? ['global-state', 'text-color']
        : settings.winds.barbColorType === BarbColorType.fixed
          ? (settings.winds.barbColor ?? ['global-state', 'text-color'])
          : getWindIntensityExpression(settings, compareExpression);
}

function getWindIntensityExpression(
    settings: WeatherSettings,
    compareExpression: ExpressionSpecification
): DataDrivenPropertyValueSpecification<ColorSpecification> {
    const palette = getPalette(GDFPalletCode.wind_heatmap, settings)!;
    assert(palette.type === 'gradientBar');
    const last = palette.stops[palette.stops.length - 1];
    return [
        'case',
        ...palette.stops.map((x) => [['<=', compareExpression, palette.getValue!(x.value)], x.color]).flat(1),
        last.color
    ] as DataDrivenPropertyValueSpecification<ColorSpecification>;
}

export function barbSizeToMultiplier(size: BarbSize) {
    return size === BarbSize.small ? 0.7 : size === BarbSize.medium ? 1.0 : 1.3;
}
